const adminArray = new Set(['秘书', '办案秘书', '首席仲裁员', '独任仲裁员', '仲裁员']);

const config = {
  'demo': {
    fullName: '长三角跨域开庭',
    shortName: '沪',
    record: true
  },
  'sh': {
    fullName: '上海仲裁委员会',
    shortName: '沪',
    record: false
  },
  'wz': {
    fullName: '温州仲裁委员会',
    shortName: '温',
    record: true
  }
}

const getFullName = (oId) => {
  return config[oId].fullName
}

const getShortName = (oId) => {
  return config[oId].fullName
}

const getRecordConfig = (oId) => {
  return config[oId].record
}

export {
  adminArray,
  getFullName,
  getShortName,
  getRecordConfig
}
